import React from "react";
import { Box, Typography, Grid, TextField, Table, TableBody, TableCell, TableHead, TableRow, Paper, } from "@mui/material";

const OrdenVitalizado = () => {
  return (
    <Paper sx={{ p: 4, maxWidth: 900, mx: "auto", mt: 4 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={8}>
          <Typography variant="h5" fontWeight="bold">
            DEL LAGO RENOVALLANTAS, S.A. DE C.V.
          </Typography>
          <Typography variant="body2">
            Circuito San Ignacio #6, Parque Industrial del Valle de Aguascalientes, Ags.
          </Typography>
          <Typography variant="body2">
            Tel: (449) 972-1600 • RFC: LRE9509149A4
          </Typography>
        </Grid>
        <Grid item xs={4} textAlign="right">
          <Typography variant="h6" fontWeight="bold" color="primary">
            ORDEN DE VITALIZADO
          </Typography>
          <Typography variant="body2">
            <strong>No:</strong> 102151
          </Typography>
        </Grid>
      </Grid>

      <Box mt={3}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField fullWidth label="Cliente" variant="outlined" size="small" />
          </Grid>
          <Grid item xs={6}>
            <TextField fullWidth label="Domicilio" variant="outlined" size="small" />
          </Grid>
          <Grid item xs={4}>
            <TextField fullWidth label="Ciudad" variant="outlined" size="small" />
          </Grid>
          <Grid item xs={4}>
            <TextField fullWidth label="Teléfono" variant="outlined" size="small" />
          </Grid>
          <Grid item xs={4}>
            <TextField fullWidth label="Fecha" type="date" InputLabelProps={{ shrink: true }} size="small" />
          </Grid>
        </Grid>
      </Box>

      <Box mt={4}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>O.P</TableCell>
              <TableCell>Unidad</TableCell>
              <TableCell>Medida</TableCell>
              <TableCell>Serie</TableCell>
              <TableCell>Marca</TableCell>
              <TableCell>Diseño</TableCell>
              <TableCell>Observaciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[...Array(5)].map((_, i) => (
              <TableRow key={i}>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>

      <Typography variant="body2" mt={2} fontStyle="italic">
        * Si el renovado no se recoge en 30 días se pierde el casco.
      </Typography>

      <Grid container justifyContent="space-between" mt={6}>
        <Grid item>
          <Typography variant="body2" align="center">
            ____________________________
          </Typography>
          <Typography variant="body2" align="center">
            Firma Renovallantas de Recibido
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body2" align="center">
            ____________________________
          </Typography>
          <Typography variant="body2" align="center">
            Firma del Cliente de Entrega
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
}
export default OrdenVitalizado